import {
    AlertPanel, DataLabel,
    DropDown,
    InputText, Radio, Seperator,
    ALink,
    Dialog,
    ELink,
    SeparatorLine
} from "components2/CommonUI";
import { APPT_TYPE, DATE_FORMAT, DATE_FORMAT_API, ID_TYPE, LANGUAGES, TIME_SLOT_FORMAT } from "constants/o2Appointment";
import moment from "moment";
import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import {
  clearCompanion,
  updateApptDateId,
  updateApptDateTime,
  updateApptTimeRange, updateApptTimeslotId, updateApptType,
  updateCompanionIdType,
  updateCompanionNricFin,
  updateCompanionPassport,
  updateHaveCompanion,
  updateLanguage,
  updateLocationDesc,
  updateLocationId,
  updateMid,
  updateMidDesc,
  updateSid,
  updateSidDesc,
  updateIsCrps,
  updateIsExperience,
  updateApptDate,
  updateApptTimeslots,
  clearApptDateTime,
  clearLocation,
  updateCompanionApptTimeslotId,
  updateCrpsError
} from "redux/o2Appointment";
import { getApptTypes, getDates, getLocations, getMainServices, getSubServices, getTimeRanges, getTimeslots } from "services/api-service2";
import { isValidPassport, safeVal, isValidNric } from "utils/common2";
import _ from "lodash";

window.mo = moment;

export const SelectCategory = ({hasLoaded, setHasLoaded, setAutoSelect}) => {
  const dispatch = useDispatch();
  const [mainServices, setMainServices] = useState([]);
  const [subServices, setSubServices] = useState([]);

  const { idType, crpsError, nricFin, passport, mid, sid, midDesc, sidDesc, bookingTxnId } = useSelector((state) => state.o2Appointment);

  // onload
  // get main services
  useEffect(() => {
    getMainServices().then((mainServices) => {
      setMainServices(mainServices);
    });
  }, []);

  // if mid have, get sub services
  useEffect(() => {
    if (mid === null) {
      batch(()=>{
        dispatch(updateSid(null));
        dispatch(updateSidDesc(null));
        dispatch(updateIsCrps(null));
        dispatch(updateCrpsError(null));
        dispatch(updateIsExperience(null));
        setSubServices([]);
      });
      return;
    }

    getSubServices(mid).then((subServices) => {
      setSubServices(subServices);
    });
  }, [mid]);

  useEffect(()=>{
    // if come from url param with id
    if(mid !== null && midDesc === null && mainServices.length > 0) {
      const mainService = mainServices.find(x=>x.id === mid);
      if(mainService) {
        dispatch(updateMidDesc(mainService.text));
      } else {
        batch(()=>{
          dispatch(updateMid(null));
          dispatch(updateSid(null));
        });
      }
    }
  }, [mid, midDesc, mainServices]);

  useEffect(()=>{
    // if come from url param with id
    if(sid !== null && sidDesc === null && mainServices.length > 0 && subServices.length > 0) {
      const subService = subServices.find(x=>x.id === sid);
      if(subService) {
        batch(()=>{
          dispatch(updateSidDesc(subService.text));
          dispatch(updateIsCrps(subService.isCrps));
          dispatch(updateIsExperience(subService.isExperience));
        });
      } else {
        dispatch(updateSid(null));
      }
    }
  }, [sid, sidDesc, mainServices, subServices]);

  const onChangeMainService = (mid) => {
    setHasLoaded(false);
    batch(()=>{
      dispatch(updateMid(parseInt(mid, 10)));
      dispatch(updateMidDesc(mainServices.find(x=>x.id === mid).text));
      dispatch(updateSid(null));
      dispatch(updateSidDesc(null));
      dispatch(updateIsCrps(null));
      dispatch(updateCrpsError(null));
      dispatch(updateIsExperience(null));

      // dispatch(updateApptType({
      //   apptTypeId: null,
      //   apptTypeCode: null,
      //   apptType: null,
      //   isSlotAvailable: null,
      //   locationId: null,
      // }));
    });
  };

  const onChangeSubService = (sid) => {
    setHasLoaded(false);
    batch(()=>{
      dispatch(updateSid(parseInt(sid, 10)));
      dispatch(updateSidDesc(subServices.find(x=>x.id === sid).text));
      dispatch(updateIsCrps(subServices.find(x=>x.id === sid).isCrps));
      dispatch(updateCrpsError(null));
      dispatch(updateIsExperience(subServices.find(x=>x.id === sid).isExperience));

      dispatch(updateApptType({
        apptTypeId: -1,
        apptTypeCode: null,
        apptType: null,
        isSlotAvailable: null,
        locationId: null,
      }));
    });
  };

  // pb-3 pb-md-4 
  return (

    <div className={"px-1 px-3 pt-64 md-pt-48 sm-pt-48 lg-mb-40 xl-mb-40"}>
      <h4 className={"text-center sm-mb-32 md-mb-32 lg-mb-48 xl-mb-48 lg-fs-32 xl-fs-32"}>How can we help?</h4>

      <div className="row justify-content-center sm-mb-40 md-mb-40 lg-mb-32 xl-mb-32">
        <div className="col-12 col-md-8 col-lg-6" style={{ border: "0px solid red" }}>
          {idType === ID_TYPE.NRIC_FIN && <DataLabel label={"Customer ID"} data={nricFin} />}
          {idType === ID_TYPE.PASSPORT && <DataLabel label={"Customer Passport"} data={passport} />}
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-12 col-md-8 col-lg-6 py-2" style={{ border: "0px solid red" }}>
          <DropDown
            key={"mainService"}
            defaultText="Select"
            label="Select category"
            items={mainServices}
            value={mid}
            disabled={bookingTxnId !== null}
            onChange={(e) => {
              // Dropdown value is string as it used InputText as the dropdown item
              onChangeMainService(parseInt(e.target.value, 10));
            }}
          />
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-12 col-md-8 col-lg-6 py-2" style={{ border: "0px solid red" }}>
          <DropDown
            key={"subService"}
            defaultText="Select"
            label="Select topic"
            items={subServices}
            value={sid}
            onChange={(e) => {
              // Dropdown value is string as it used InputText as the dropdown item
              setAutoSelect(true);
              onChangeSubService(parseInt(e.target.value, 10, 10));

              // console.log("**updateApptType0");
              // setTimeout(()=>{
              // dispatch(updateApptType({
              //   apptTypeId: null,
              //   apptTypeCode: null,
              //   apptType: null,
              //   isSlotAvailable: null,
              //   locationId: null,
              // }));
              // }, 0);
            }}
            disabled={mid === null || bookingTxnId !== null}
            isInvalid={crpsError}
          />
          {crpsError && (<>
            <div className="input-error-msg" style={{ display: "block" }}>
              {crpsError}
            </div>
          </>) }
        </div>
      </div>
    </div>
  );
};

// Depends on mid, sid
// eslint-disable-next-line 
export const SelectApptType = ({/*edit,*/ hasLoaded, setHasLoaded, autoSelect, setAutoSelect}) => {
  const [apptTypes, setApptTypes] = useState([]);
  const dispatch = useDispatch();
  const { mid, sid, apptTypeId, nricFin, passport, isCrps } = useSelector((state) => state.o2Appointment);
  // const [hasLoaded, setHasLoaded] = useState(false);

  // Logic to dtermine auto select appt type
  const afterApptTypesUpdate = (_apptTypes ) => {
    let _apptType = null;

    if (_apptTypes.length === 1) {
      _apptType = _apptTypes[0];
    } else {
      // Multiple appt type
      // Auto select appt type if only one is available
      const isPhoneAvail =
        _apptTypes.findIndex((x) => x.apptType === APPT_TYPE.PHONE && x.isSlotAvailable) >= 0;
      const isVisitAvail =
        _apptTypes.findIndex((x) => x.apptType === APPT_TYPE.VISIT && x.isSlotAvailable) >= 0;
      if (isPhoneAvail && isVisitAvail) {
        // Yes. This is redundant.
        _apptType = null;
      } else if (isPhoneAvail) {
        // only phone avail
        _apptType = _apptTypes.find((x) => x.apptType === APPT_TYPE.PHONE);
      } else if (isVisitAvail) {
        _apptType = _apptTypes.find((x) => x.apptType === APPT_TYPE.VISIT);
      }
    }


    // if(_apptType) {
    //   dispatch(updateApptType({
    //     apptTypeId: _apptType.id,
    //     apptTypeCode: _apptType.apptTypeCode,
    //     apptType: _apptType.apptType,
    //     isSlotAvailable: _apptType.isSlotAvailable,
    //     locationId: _apptType.defaultLocationId // phone visit will have defaultLocationId
    //   }));
    // }

    

    console.log("**updateApptType2", _apptType);
    dispatch(updateApptType({
      apptTypeId: _apptType ? _apptType.id : null,
      apptTypeCode: _apptType ? _apptType.apptTypeCode: null,
      apptType: _apptType ? _apptType.apptType : null,
      isSlotAvailable: _apptType ? _apptType.isSlotAvailable : null, 
      locationId: _apptType && _apptType.defaultLocationId ? _apptType.defaultLocationId : null // phone visit will have defaultLocationId
    }));
    
    if(!_apptType) {
      dispatch(clearApptDateTime());
      dispatch(clearCompanion());
      dispatch(clearLocation());
    }
  };

  useEffect(() => {
    // if(!edit) {
      // dispatch(updateApptType({
      //   apptTypeId: null, 
      //   apptTypeCode: null,
      //   apptType: null,
      //   isSlotAvailable: null,
      //   locationId: null
      // }));
    // }

    if (mid === null || sid === null) {
      setApptTypes([]);
      return;
    }

    setApptTypes([]);
    // dispatch(updateApptType({
    //   apptTypeId: null,
    //   apptTypeCode: null,
    //   apptType: null,
    //   isSlotAvailable: null,
    //   locationId: null,
    // }));

    getApptTypes({ subServiceId: sid, identity: nricFin || passport, isCrps }).then((_apptTypes) => {
      if(!_apptTypes) {
        return;
      }
      if(isCrps && _apptTypes.length === 0) {
        batch(()=>{
          dispatch(updateCrpsError("You must be a Singapore Citizen or Permanent Resident, and within 6 months of turning 55 or 3 months of turning 65, to select this option."));
          // clear up all in case already have selected infos and doing back and next action
          // 1. with crps success
          // 2. back 
          // 3. change to passport or crps fail id
          // 4. next
          dispatch(updateApptType({
            apptTypeId: null,
            apptTypeCode: null,
            apptType: null,
            isSlotAvailable: null,
            locationId: null,
          }));
          dispatch(updateApptTimeslots([]));
          dispatch(updateApptTimeslotId(null));
          dispatch(updateApptDateTime(null));
          dispatch(updateCompanionApptTimeslotId(null));
        });
      }
      if(isCrps && _apptTypes.length > 0) {
        dispatch(updateCrpsError(null));
      }
      setHasLoaded(true);
      setApptTypes(_apptTypes);
      // if(!edit) {
      //   afterApptTypesUpdate(_apptTypes);
      // }
    });
  }, [mid, sid, isCrps]);

  useEffect(()=>{
    if(apptTypeId === -1)  {
      setApptTypes([]);
      dispatch(updateApptType({
        apptTypeId: null,
        apptTypeCode: null,
        apptType: null,
        isSlotAvailable: null,
        locationId: null,
      }));
      return;
    }
    if(apptTypeId === null) {
      console.log("**updateApptType1", apptTypes,  apptTypeId);
      afterApptTypesUpdate(apptTypes);
    }
  },[apptTypes, apptTypeId]);

  const onChangeApptType = (apptTypeId) => {
    setAutoSelect(true);
    const apptType = apptTypes.find((x) => x.id === apptTypeId);
    batch(()=>{
      dispatch(updateApptType({
        apptTypeId, 
        apptTypeCode: apptType?.apptTypeCode,
        apptType: apptType?.apptType, 
        isSlotAvailable: apptType?.isSlotAvailable,
        locationId: apptType.defaultLocationId ? apptType.defaultLocationId : null // phone visit will have defaultLocationId
      }));
      dispatch(updateHaveCompanion(false));

      dispatch(updateApptDateId(null));
      dispatch(updateApptDate(null));

      dispatch(updateApptTimeRange({
        id: null,
        startTime: null,
        endTime: null
      }));

      dispatch(updateApptTimeslots([]));
      dispatch(updateApptTimeslotId(null));
      dispatch(updateApptDateTime(null));
      dispatch(updateCompanionApptTimeslotId(null));
    });


    // setTimeout(()=>{
    //   // timeout to cause SelectDateTimeRange
    //   // dates, apptDateId effect to run later 
    //   dispatch(updateApptDateId(null));
    //   dispatch(updateApptDate(null));

    //   dispatch(updateApptTimeRange({
    //     id: null,
    //     startTime: null,
    //     endTime: null
    //   }));

    //   batch(()=>{
    //     dispatch(updateApptTimeslots([]));
    //     dispatch(updateApptTimeslotId(null));
    //     dispatch(updateApptDateTime(null));
    //     dispatch(updateCompanionApptTimeslotId(null));
    //   });
     
    // }, 0);
  };

  const isPhoneTypeExist = apptTypes?.findIndex((x) => x.apptType === APPT_TYPE.PHONE) >= 0;
  const isVisitTypeExist = apptTypes?.findIndex((x) => x.apptType === APPT_TYPE.VISIT) >= 0;
  const isPhoneTypeSlotAvail =
    apptTypes?.findIndex((x) => x.apptType === APPT_TYPE.PHONE && x.isSlotAvailable) >= 0;
  const isVisitTypeSlotAvail =
    apptTypes?.findIndex((x) => x.apptType === APPT_TYPE.VISIT && x.isSlotAvailable) >= 0;

  let noAvailMessage = null;
  let nothingAvail = false;

  if(hasLoaded) {
    // if don't check hasLoaded, will show "There are currently no available phone call or service centre appointments" when page first load
    if (isPhoneTypeExist && !isPhoneTypeSlotAvail && isVisitTypeExist && !isVisitTypeSlotAvail) {
      // both have, & bot not avail
      noAvailMessage =
        "There are currently no available phone call or service centre appointment timeslots.";

      nothingAvail = true;
    } else if (isPhoneTypeExist && !isPhoneTypeSlotAvail) {
      // phone exist & not avail, but visit may exist & avial
      noAvailMessage = "There are currently no available phone call appointment timeslots.";
      if(!isVisitTypeExist || (isVisitTypeExist && !isVisitTypeSlotAvail)) {
        nothingAvail = true;
      }
    } else if (isVisitTypeExist && !isVisitTypeSlotAvail) {
      // visit exist & not avail, but phone may exist & avail
      noAvailMessage = "There are currently no available service centre appointment timeslots.";
      if(!isPhoneTypeExist || (isPhoneTypeExist && !isPhoneTypeSlotAvail)) {
        nothingAvail = true;
      }
    } else if(!isPhoneTypeExist && !isVisitTypeExist) {
      // both not exist
      nothingAvail = true;
      noAvailMessage =
        "There are currently no available phone call or service centre appointment timeslots.";
      // noAvailMessage = "There are currently no available appointment timeslots.";
      // if(isCrps) {
      //   noAvailMessage = <>
      //     <p className="text-justify">
      //       Seems like you do not meet the age eligibility for CRPS. The
      //       CRPS is tailored to help members in these groups plan for their
      //       retirement:
      //     </p>

      //     <ol type="i" className="text-justify mt-3">
      //       <li>Members reaching 55 in 6 months or less, or</li>
      //       <li>
      //         Members reaching Payout Eligibility Age (65 year old) in 3
      //         months or less.
      //       </li>
      //     </ol>
      //   </>;
      // }
    } 
  }

  if(!hasLoaded) {
    return <></>;
  }

  // console.log("noAvailMessage", noAvailMessage)

  return (
    <>
      <div className={"pb-3"}>
       <SeparatorLine style={{ marginLeft: 0, marginRight: 0 }} />
      </div>
      <h4 className={"mb-4 text-center"} >Select appointment type</h4>

      {noAvailMessage !== null && <AlertPanel type={"warning"}>{noAvailMessage}</AlertPanel>}

      {apptTypes?.length > 1 && !nothingAvail && (
        <>
          <div className="pt-2">
            <div className="row justify-content-center" style={{ marginBottom: 16 }}>
              <div className="col-12 col-md-8 col-lg-6">
                <div>
                  <div>Appointment type</div>
                </div>
              </div>
            </div>

            {apptTypes?.map((apptType, idx) => (
              <div key={apptType.id} className="row justify-content-center">
                <div className="col-12 col-md-8 col-lg-6">
                  <Radio
                    id="apptTypeId"
                    label={
                      <>
                        <div>{apptType.text}</div>
                        <div className="second-row-caption">{apptType.note}</div>
                      </>
                    }
                    value={apptType.id}
                    checked={apptType.id === apptTypeId}
                    onChange={(e) => {
                      if (apptType.isSlotAvailable) {
                        onChangeApptType(e.target.value);
                      }
                    }}
                    needCol={false}
                    disabled={!apptType.isSlotAvailable}
                    labelStyle={idx == apptTypes.length -1 ? {marginBottom:0} : {}}
                  />
                </div>
              </div>
            ))}
          </div>
        </>
      )}
      {apptTypes?.length === 1 && !nothingAvail && (
        <>
          <div className="row justify-content-center pb-3">
            <div className="col-12 col-md-8 col-lg-6" style={{ border: "0px solid red" }}>
              <DataLabel label={"Appointment type"} data={apptTypes[0].text} />
            </div>
          </div>
        </>
      )}
    </>
  );
};

const NRIC_FIN_ERROR_MSG = "Enter a valid NRIC number (e.g. S1234567A) or FIN number (e.g. F1234567A).";
const PASSPORT_ERROR_MSG = "Enter a valid passport number.";

// Depends on apptTypeId
/* eslint-disable react/display-name */
export const SelectCompanion = React.forwardRef(({validate, setAutoSelect}, ref) => {
  const refNricFin = useRef();
  const refPassport = useRef();
  const [nricFinError, setNricFinError] = useState(null);
  const [passportError, setPassportError] = useState(null);

  const dispatch = useDispatch();
  const { apptTypeId, haveCompanion, companionIdType,companionPassport,companionNricFin } = useSelector(
    (state) => state.o2Appointment
  );

  useEffect(()=>{
    if(companionPassport && refPassport?.current) {
      refPassport.current.value = companionPassport;
    }
  },[refPassport, companionPassport]);

  useEffect(()=>{
    if(companionNricFin && refNricFin?.current) {
      refNricFin.current.value = companionNricFin;
    }
  },[refNricFin, companionNricFin]);


  useImperativeHandle(ref, () => ({
    // have to pass as value parameter as selection have not yet render when this is called
    isValid(haveCompanion, companionIdType) {
      if(!haveCompanion) {
        return true;
      }
      if(companionIdType === ID_TYPE.NRIC_FIN) {
        return isValidNric(safeVal(refNricFin));
      } 
      if(companionIdType === ID_TYPE.PASSPORT) {
        return isValidPassport(safeVal(refPassport));
      }
    },
    // validate() {
    //   if(!haveCompanion) {
    //     return true;
    //   }
    //   if(companionIdType === ID_TYPE.NRIC_FIN) {
    //     if(!validateNricFin()) {
    //       // window.scrollTo and window.scrollY are not working when height is set 100% or 100vh to the body or container div
    //       // window.scrollTo(0, refNricFin.current.getBoundingClientRect().top + window.scrollY - 10);
    //       setTimeout(()=>document.body.scrollTo({ top: refNricFin.current.getBoundingClientRect().top + document.body.scrollTop - 50 }), 100);
    //       return false;
    //     }
    //     return true;
    //   } 
    //   if(companionIdType === ID_TYPE.PASSPORT) {
    //     if(!validatePassport()) {
    //       setTimeout(()=>document.body.scrollTo({ top: refPassport.current.getBoundingClientRect().top + document.body.scrollTop - 50 }), 100);
    //       return false;
    //     }
    //     return true;
    //   }
    // }
  }));

  // useEffect(()=>{
  //   dispatch(clearCompanion());
  // }, [apptTypeId]);

  const onChangeHaveCompanion = (haveCompanion) => {
    setAutoSelect(true);
    batch(()=>{
      // deselect auto selected timeslot if companion change
      // dispatch(updateInitialApptTimeslotId(null));
      // dispatch(updateHasTimeslotSelectionChanges(new Date()));
      dispatch(updateApptTimeslotId(null));
      dispatch(updateHaveCompanion(haveCompanion));
    })
    if(!haveCompanion){
      dispatch(clearCompanion());
    }
  };

  const onChangeCompanionIdType = (companionIdType) => {
    setAutoSelect(true);
    batch(()=>{
      dispatch(updateCompanionIdType(companionIdType));
      dispatch(updateCompanionNricFin(null));
      dispatch(updateCompanionPassport(null));
    })
  };

  const onChangeCompanionNricFin = (companionNricFin) => {
    dispatch(updateCompanionNricFin(companionNricFin));
  };

  const onChangeCompanionPassport = (companionPassport) => {
    dispatch(updateCompanionPassport(companionPassport));
  };

  const validateNricFin = () => {
    if (!isValidNric(safeVal(refNricFin))) {
      setNricFinError(NRIC_FIN_ERROR_MSG);
      return false;
    } else {
      // Timeout is to delay rendering if there is no error,
      // which is to let click event on the Next button to be triggered first.
      setTimeout(() => setNricFinError(null), 100);
      return true;
    }
  };

  const validatePassport = () => {
    if (!isValidPassport(safeVal(refPassport))) {
      setPassportError(PASSPORT_ERROR_MSG);
    } else {
      // Timeout is to delay rendering if there is no error,
      // which is to let click event on the Next button to be triggered first.
      setTimeout(() => setPassportError(null), 100);
      return true;
    }
  };

  const onBlurNricFin = (hasTouched) => {
    if(safeVal(refNricFin) === "" && hasTouched) {
      setNricFinError("This field is mandatory.");
      return false;
    }

    if (safeVal(refNricFin) !== "") {
      if (validateNricFin()) {
        onChangeCompanionNricFin(safeVal(refNricFin).trim().toUpperCase());
      } else {
        onChangeCompanionNricFin(null);
      }
    }
  };

  const onBlurPassport = (hasTouched) => {
    if(safeVal(refPassport) === "" && hasTouched) {
      setPassportError("This field is mandatory.");
      return false;
    }

    if (safeVal(refPassport) !== "") {
      if (validatePassport()) {
        onChangeCompanionPassport(safeVal(refPassport).trim().toUpperCase());
      } else {
        onChangeCompanionPassport(null);
      }
    }
  };

  const onChangeIdType = (idType) => {
    onChangeCompanionIdType(idType);
    if (idType === ID_TYPE.NRIC_FIN) {
      setPassportError(null);
    } else if (idType === ID_TYPE.PASSPORT) {
      setNricFinError(null);
    }
  };

  return (
    <>
      <div className="row justify-content-center sm-mt-32 md-mt-32 lg-mt-24 xl-mt-24" style={{ marginBottom: 4 }}>
        <div className="col-12 col-md-8 col-lg-6">
          <div>
            <div>Is another person joining this appointment for additional enquiries?</div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-12 col-md-4 col-lg-3">
          <div>
            <Radio
              id="haveCompanion"
              label={
                <>
                  <div>Yes</div>
                </>
              }
              value={true}
              checked={haveCompanion}
              onChange={(e) => {
                onChangeHaveCompanion(e.target.value);
              }}
              needCol={false}
              labelClass={"sm-mb-8 md-mb-0 lg-mb-0 xl-mb-0"}
            />
          </div>
        </div>
        <div className="col-12 col-md-4 col-lg-3">
          <div>
            <div>
              <Radio
                id="haveCompanion"
                label={
                  <>
                    <div>No</div>
                  </>
                }
                value={false}
                checked={!haveCompanion}
                onChange={(e) => {
                  onChangeHaveCompanion(e.target.value);
                }}
                needCol={false}
                labelClass={"sm-mb-8 md-mb-0 lg-mb-0 xl-mb-0"}
              />
            </div>
          </div>
        </div>
      </div>
      {haveCompanion && (
        <>
          <div className="row justify-content-center sm-mt-32 md-mt-32 lg-mt-24 xl-mt-24" style={{ marginBottom: 4 }}>
            <div className="col-12 col-md-8 col-lg-6">
              <div>
                <div>Select ID type of companion</div>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-12 col-md-4 col-lg-3">
              <div>
                <Radio
                  id="companionIdType"
                  label={<div>NRIC or FIN</div>}
                  value={ID_TYPE.NRIC_FIN}
                  checked={companionIdType === ID_TYPE.NRIC_FIN}
                  onChange={() => onChangeIdType(ID_TYPE.NRIC_FIN)}
                  needCol={false}
                  labelClass={"sm-mb-8 md-mb-0 lg-mb-0 xl-mb-0"}
                />
              </div>
            </div>
            <div className="col-12 col-md-4 col-lg-3">
              <div>
                <Radio
                  id="companionIdType"
                  label={<div>Passport number</div>}
                  value={ID_TYPE.PASSPORT}
                  checked={companionIdType === ID_TYPE.PASSPORT}
                  onChange={() => onChangeIdType(ID_TYPE.PASSPORT)}
                  needCol={false}
                  labelClass={"sm-mb-8 md-mb-0 lg-mb-0 xl-mb-0"}
                />
              </div>
            </div>
          </div>

          {companionIdType === ID_TYPE.NRIC_FIN && (
            <div className="row justify-content-center sm-mt-32 md-mt-32 lg-mt-24 xl-mt-24">
              <div className="col-12 col-md-8 col-lg-6">
                <InputText
                  label="Enter NRIC or FIN"
                  ref={refNricFin}
                  onBlur={onBlurNricFin}
                  errorMessage={nricFinError}
                  isInvalid={nricFinError !== null}
                  // value={mobile}
                  // onChange={onChangeMobile}
                  // isInvalid={nricFinError !== null}
                />
              </div>
            </div>
          )}

          {companionIdType === ID_TYPE.PASSPORT && (
            <div className="row justify-content-center sm-mt-32 md-mt-32 lg-mt-24 xl-mt-24">
              <div className="col-12 col-md-8 col-lg-6">
                <InputText
                  label="Enter passport number"
                  ref={refPassport}
                  onBlur={onBlurPassport}
                  errorMessage={passportError}
                  isInvalid={passportError !== null}
                  // value={companionPassport}
                  // onChange={onChangeMobile}
                  // isInvalid={nricFinError !== null}
                />
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
});

// Depends on apptTypeId
export const SelectLanguage = () => {
  const dispatch = useDispatch();
  const { language, apptTypeId } = useSelector((state) => state.o2Appointment);
  const DEFAULT_LANG = "EN";

  // useEffect(()=>{
  //   dispatch(updateLanguage(DEFAULT_LANG));
  // },[apptTypeId]);

  const onChangeLanguage = (lang) => {
    dispatch(updateLanguage(lang));
  };

  return (
    <>
      <div className="row justify-content-center sm-mt-32 md-mt-32 lg-mt-24 xl-mt-24" style={{ marginBottom: 16 }}>
        <div className="col-12 col-md-8 col-lg-6" style={{ border: "0px solid red" }}>
          <div>Language</div>
        </div>
      </div>
      {LANGUAGES.map((lang) => (
        <div key={lang.id} className="row justify-content-center">
          <div className="col-12 col-md-8 col-lg-6" style={{ border: "0px solid red" }}>
            <Radio
              id="languageId"
              label={lang.language}
              value={lang.id}
              checked={lang.id === language}
              onChange={(e) => {
                onChangeLanguage(e.target.value);
              }}
              needCol={false}
            />
          </div>
        </div>
      ))}
    </>
  );
};

// Depends on apptTypeId, apptType
export const SelectLocation = ({autoSelect, setAutoSelect}) => {
  const dispatch = useDispatch();
  const { apptTypeId, apptType, locationId } = useSelector((state) => state.o2Appointment);
  const [locations, setLocations] = useState([]);
  const refLocationInfoDialog = useRef();

  useEffect(() => {
    if (!apptTypeId) {
      batch(()=>{
        dispatch(updateLocationId(null));
        dispatch(updateLocationDesc(null));
      });
      return;
    }

    if(apptType === APPT_TYPE.PHONE) {
      batch(()=>{
        // dispatch(updateLocationId(null));
        dispatch(updateLocationDesc(null));
      });
      return;
    }

    getLocations(apptTypeId).then((locations) => {
      if(apptTypeId === null) {
        return;
      }
      setLocations(locations);
      
    });
  }, [apptTypeId, apptType]);

  useEffect(()=>{
    if(locationId !== null) {
      // no need auto select
      return;
    }
    const defaultLocation = locations.find((x) => x.hasEarliestTimeslot);
      if (defaultLocation) {
        batch(()=>{
          dispatch(updateLocationId(defaultLocation.id));
          dispatch(updateLocationDesc(defaultLocation.text));
        });
        return;
      }
      batch(()=>{
        dispatch(updateLocationId(null));
        dispatch(updateLocationDesc(null));
      });
  },[locations, locationId]);

  const clkLocationDetail = () => {
    window.open(window.locationInfoLink, "_blank");
    // refLocationInfoDialog.current.show();
  }
  
  if(apptType === APPT_TYPE.PHONE) {
    return <></>;
  }

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 col-md-8 col-lg-6" style={{ border: "0px solid red" }}>
          <DropDown
            label="Service centre"
            items={locations}
            disabledItem={x=>!x.isSlotAvailable}
            value={locationId}
            onChange={(e) => {
              if(!locations.find(l=>l.id===parseInt(e.target.value, 10)).isSlotAvailable) {
                return;
              }
              setAutoSelect(true);

              // Dropdown value is string as it used InputText as the dropdown item
              batch(()=>{
                dispatch(updateLocationId(parseInt(e.target.value, 10)));
                dispatch(updateLocationDesc(locations.find((x) => x.id===parseInt(e.target.value, 10))?.text));

                dispatch(updateApptDateId(null));
                dispatch(updateApptDate(null));

                dispatch(updateApptTimeRange({
                  id: null,
                  startTime: null,
                  endTime: null
                }));

                dispatch(updateApptTimeslots([]));
                dispatch(updateApptTimeslotId(null));
                dispatch(updateApptDateTime(null));
                dispatch(updateCompanionApptTimeslotId(null));
              });

              // setTimeout(()=>{
              //   // timeout to cause SelectDateTimeRange
              //   // dates, apptDateId effect to run later 
              //   dispatch(updateApptDateId(null));
              //   dispatch(updateApptDate(null));

              //   dispatch(updateApptTimeRange({
              //     id: null,
              //     startTime: null,
              //     endTime: null
              //   }));

              //   batch(()=>{
              //     dispatch(updateApptTimeslots([]));
              //     dispatch(updateApptTimeslotId(null));
              //     dispatch(updateApptDateTime(null));
              //     dispatch(updateCompanionApptTimeslotId(null));
              //   });
              // }, 0);
            }}
          />
          <ALink onClick={clkLocationDetail} >
            View location details
          </ALink>
        </div>
      </div>
      <Dialog ref={refLocationInfoDialog} header={"Service centre locations"}  >
        <div>
          <div>CPF Bishan</div>
          <div className="label-bold">3 Bishan Place, #01-01, Singapore 579838</div>
          <div>The nearest MRT Station is Bishan.</div>
          <ELink href={"https://www.google.com"}>View map </ELink>
        </div>
        <div>
          <div>CPF Jurong</div>
          <div className="label-bold">21 Jurong Gateway Road, #01-01, Singapore 608546</div>
          <div>
            The nearest MRT Station is Jurong East.
          </div>
          <ELink href={"https://www.google.com"}>View map </ELink>
        </div>
        <div>
          <div>CPF Maxwell</div>
          <div className="label-bold">The URA Centre East Wing (opposite Maxwell Food Centre) 45 Maxwell Road, #01-11, Singapore 069118</div>
          <div>
            The nearest MRT station is Tanjong Pagar.
          </div>
          <ELink href={"https://www.google.com"}>View map </ELink>
        </div>

        <div>
          <div>CPF Tampines</div>
          <div className="label-bold">1 Tampines Central, #01-01, Singapore 529508</div>
          <div>
            The nearest MRT Station is Tampines.
          </div>
          <ELink href={"https://www.google.com"}>View map </ELink>
        </div>

      </Dialog>
    </>
  );
};

const generateRange = (start, end, interval, firstSlotStart = null, firstSlotEnd, lastSlotStart, lastSlotEnd) => {
    start = moment(start, TIME_SLOT_FORMAT);
    end = moment(end, TIME_SLOT_FORMAT);
    const result = [];
    let current = start;
    let i = firstSlotStart ? 1 : 0;

    if(firstSlotStart) {
      firstSlotStart = moment(firstSlotStart, TIME_SLOT_FORMAT);
      firstSlotEnd = moment(firstSlotEnd, TIME_SLOT_FORMAT);
      result.push({id: 1, startTime: firstSlotStart.format(TIME_SLOT_FORMAT), 
            endTime: firstSlotEnd.format(TIME_SLOT_FORMAT), 
            text: `${firstSlotStart.format(TIME_SLOT_FORMAT)} to ${firstSlotEnd.format(TIME_SLOT_FORMAT)}`});
    }

    // {id:1, text: "09:00am to 10:00am", startTime: "0900", endTime: "1000"},
    while (current.isBefore(end)) {
        const currentEnd = current.clone().add(interval, "minutes");
        result.push({id: ++i, startTime: current.format(TIME_SLOT_FORMAT), 
          endTime: currentEnd.format(TIME_SLOT_FORMAT), 
          text: `${current.format(TIME_SLOT_FORMAT)} to ${currentEnd.format(TIME_SLOT_FORMAT)}`});
        current = current.add(interval, "minutes");
    }

    if(lastSlotStart) {
      lastSlotStart = moment(lastSlotStart, TIME_SLOT_FORMAT);
      lastSlotEnd = moment(lastSlotEnd, TIME_SLOT_FORMAT);
      result.push({id: result.length+1, startTime: lastSlotStart.format(TIME_SLOT_FORMAT), 
            endTime: lastSlotEnd.format(TIME_SLOT_FORMAT), 
            text: `${lastSlotStart.format(TIME_SLOT_FORMAT)} to ${lastSlotEnd.format(TIME_SLOT_FORMAT)}`});
    }
    return result;
}

const filterRangeByAvailbleSlots = (range, timeslots) => {
    return range.filter((rangeItem) => {
        return timeslots.find((timeslot) => {
            return (moment(timeslot.text, TIME_SLOT_FORMAT).isBetween(moment(rangeItem.startTime, TIME_SLOT_FORMAT), moment(rangeItem.endTime, TIME_SLOT_FORMAT), undefined, "[)" /* inclusion of the start time */)) 
        });
    });
}

// Depends on apptTypeId, apptType, locationId
export const SelectDateTimeRange = ({autoSelect, setAutoSelect,edit}) => {
  const dispatch = useDispatch();
  const { haveCompanion, isCrps, apptTypeId, apptTimeslotId, apptTypeCode, 
    apptType, locationId, apptDateId, apptTimeRangeId, apptTimeslots,
    apptTimeRangeStartTime, apptTimeRangeEndTime,
    sid
  } = useSelector((state) => state.o2Appointment);
  const [dates, setDates] = useState([]);
  const [timeRanges, setTimeRanges] = useState([]);

  useEffect(()=>{
    if(edit && apptTimeslotId !== null && apptTimeRangeId === null && timeRanges.length > 0) {
      //select time range based on timeslotid
      const ts= apptTimeslots.find(x=>x.id===apptTimeslotId);
      if(ts) {
        const tsToday = moment(moment(ts.apptDateTime).format("HHmm"), "HHmm");
        const tr = timeRanges.find(x=> tsToday.isBetween(moment(x.startTime, TIME_SLOT_FORMAT), moment(x.endTime, TIME_SLOT_FORMAT), undefined, "[]"))
        if(tr) {
          dispatch(updateApptTimeRange({
          id: tr.id,
          startTime: tr.startTime,
          endTime: tr.endTime,
        }));

        }
        // if(moment(ts.apptDateTime).isBetween.)
      }
    }
  }, [edit, apptTimeslotId, apptTimeRangeId, timeRanges, apptTimeslots]);

  useEffect(() => {
    // if visit location wait for locationId to be set
    // if(apptType === APPT_TYPE.VISIT && !locationId) {
    //   return;
    // }

    // if phone appointment, no need locationId
    // if(apptType === APPT_TYPE.PHONE && locationId) {
    //   return;
    // }
    
    if(apptTypeId === null || locationId === null) {
      // wait for both appt type and location
      return;
    }

    setDates([]);
    getDates(apptTypeId, locationId).then((dates) => {
      setDates(dates);

      if(autoSelect) {
        batch(()=>{
          dispatch(updateApptDateId(dates[0].id));
          dispatch(updateApptDate(moment(dates[0].text, DATE_FORMAT).toDate()));
        });
      }
    });
  }, [apptTypeId, locationId, haveCompanion]); 

  // useEffect(()=>{
  //   if(apptDateId !== null) {
  //     return;
  //   }
  //   if(dates.length > 0) {
  //     dispatch(updateApptDateId(dates[0].id));
  //     dispatch(updateApptDate(moment(dates[0].text, DATE_FORMAT).toDate()));
  //   }
  // },[dates, apptDateId]);

  const getNextTimeSlot = (timeSlotId) => {
    const index = apptTimeslots.findIndex((x) => x.id === timeSlotId);
    const nextTimeSlot = apptTimeslots[index + 1];

    if (_.isEmpty(nextTimeSlot)) {
      return null;
    }

    const curTimeSlot = apptTimeslots[index];
    if (
      moment(nextTimeSlot.text, TIME_SLOT_FORMAT).isSame(
        moment(curTimeSlot.text, TIME_SLOT_FORMAT).add(
          curTimeSlot.timeslotInterval,
          "minutes"
        )
      )
    ) {
      return { id: nextTimeSlot.id, text: nextTimeSlot.text };
    }

    return null;
  };

  const companionTimeslotFilter = ts=> {
    if(haveCompanion || isCrps) {
      if(getNextTimeSlot(ts.id)) {
        return true;
      } 
      return false;
    } 
    return true;
  };

  const selectNextDate = () => {
    const dIdx = dates.findIndex(d=>d.id==apptDateId);
    if(dIdx < dates.length - 1) {
      const d = dates[dIdx+1];
      dispatch(updateApptDateId(d.id));
      dispatch(updateApptDate(moment(d.text, DATE_FORMAT).toDate()));
      // delete previous date
      dates.splice(dIdx, 1);
      setDates(dates);
    }
  }


  useEffect(() => {
    console.log("**apptTimeslots change");
    if(!apptTypeCode || apptTimeslots.length === 0) {
      return;
    }

    // const range = generateRange("08:00", "18:00", 60);
    // filterRangeByAvailbleSlots(range, timeslots);
    // CA: {startTime: "08:00", endTime: "18:00", interval: 60 },
    const { startTime, endTime, interval, firstSlotStart, firstSlotEnd, lastSlotStart, lastSlotEnd } = window.MAP_SLOT_RANGE_BY_APPT_TYPE_CODE[apptTypeCode];
    const range = generateRange(startTime, endTime, interval, firstSlotStart, firstSlotEnd, lastSlotStart, lastSlotEnd);
    console.log("range", range);

    const filteredRange = filterRangeByAvailbleSlots(range, apptTimeslots.filter(companionTimeslotFilter));
    if(filteredRange.length === 0) {
      // try next date
      selectNextDate();
    }

    console.log("filteredRange", filteredRange);
    
    setTimeRanges(filteredRange);

    if(autoSelect) {
      if(filteredRange.length > 0) {
        dispatch(updateApptTimeRange({
          id: filteredRange[0].id,
          startTime: filteredRange[0].startTime,
          endTime: filteredRange[0].endTime,
        }));
      } 
    }

  },[apptTypeCode, apptTimeslots, haveCompanion]);

  useEffect(()=>{
    // auto select is not on, sid is present and there is no time range selected
    // This will happen if page came in with url prameter
    if(!autoSelect && sid && !apptTimeRangeId && dates.length > 0) {
      setAutoSelect(true);
      batch(()=>{
        dispatch(updateApptDateId(dates[0].id));
        dispatch(updateApptDate(moment(dates[0].text, DATE_FORMAT).toDate()));
      });
    }
  },[autoSelect, sid, apptTimeRangeId, dates]);

  // useEffect(()=>{
  //   if(apptTimeRangeId !== null) {
  //     return;
  //   }

  //   if(timeRanges.length > 0) {
  //     dispatch(updateApptTimeRange({
  //       id: timeRanges[0].id,
  //       startTime: timeRanges[0].startTime,
  //       endTime: timeRanges[0].endTime,
  //     }));
  //   }
  // },[timeRanges, apptTimeRangeId]);

  // useEffect(() => {
  //   // if visit location wait for locationId to be set
  //   if(apptType === APPT_TYPE.VISIT && !locationId) {
  //     return;
  //   }

  //   // if phone appointment, no need locationId
  //   if(apptType === APPT_TYPE.PHONE && locationId) {
  //     return;
  //   }

  //   getTimeRanges(apptTypeId, locationId).then((timeRanges) => {
  //     setTimeRanges(timeRanges);
  //     if(timeRanges.length > 0) {
  //       dispatch(updateApptTimeRange({
  //         id: timeRanges[0].id,
  //         startTime: timeRanges[0].startTime,
  //         endTime: timeRanges[0].endTime,
  //       }));
  //     }
  //   });
  // }, [apptTypeId, locationId, apptDateId]);
  //
  //
  const rangeTimeslotFilter = (ts, startTime, endTime) => {
    if(apptTimeRangeStartTime && apptTimeRangeEndTime) {
      const tsTime = moment(ts.text, TIME_SLOT_FORMAT);
      const tsTimeRangeStart = moment(startTime, TIME_SLOT_FORMAT);
      const tsTimeRangeEnd = moment(endTime, TIME_SLOT_FORMAT);
      if(tsTime.isBetween(tsTimeRangeStart, tsTimeRangeEnd, undefined, "[]")) {
        return true;
      }
      return false;
    }
    return true;
  };

  return (
    <>
      <div className="row justify-content-center sm-mt-32 md-mt-32 lg-mt-24 xl-mt-24" style={{ marginBottom: 4 }}>
        <div className="col-12 col-md-8 col-lg-6">
          <div>
            <div>Select date and time range</div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center" style={{marginBottom:4}}>
        <div className="col-12 col-md-8 col-lg-6">
          <DropDown
            // defaultText="Select"
            items={dates}
            value={apptDateId}
            onChange={(e)=>{
              setAutoSelect(true);

              batch(()=>{
                dispatch(updateApptDateId(e.target.value));
                const d = dates.find((date) => date.id === e.target.value);
                dispatch(updateApptDate(moment(d.text, DATE_FORMAT).toDate()));
              });

              // setTimeout(()=>{}, 0);
              // dispatch(updateApptTimeRange({
              //   id: null,
              //   startTime: null,
              //   endTime: null
              // }));

              batch(()=>{
                dispatch(updateApptTimeslots([]));
                dispatch(updateApptTimeslotId(null));
                dispatch(updateApptDateTime(null));
                dispatch(updateCompanionApptTimeslotId(null));
              });
            }}
          />
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-12 col-md-8 col-lg-6">
          <DropDown
            // defaultText="Select"
            items={timeRanges}
            value={apptTimeRangeId}
            onChange={(e)=>{
              const timeRange = timeRanges.find((timeRange) => timeRange.id === parseInt(e.target.value, 10)); 
              batch(()=>{
                const _filteredApptTimeslots = apptTimeslots?.filter(companionTimeslotFilter)
                                                .filter((ts)=>rangeTimeslotFilter(ts, timeRange.startTime, timeRange.endTime));
                if(_filteredApptTimeslots.length > 0) {
                  // dispatch(updateApptTimeslotId(_filteredApptTimeslots[0].id));
                  batch(()=>{
                    dispatch(updateApptTimeslotId(_filteredApptTimeslots[0].id));
                    dispatch(updateApptDateTime(moment(_filteredApptTimeslots[0].apptDateTime).toDate()));
                    if(haveCompanion || isCrps) {
                      const nextSlot = getNextTimeSlot(_filteredApptTimeslots[0].id);
                      if(nextSlot) {
                        dispatch(updateCompanionApptTimeslotId(nextSlot.id));
                      }
                    } else {
                      dispatch(updateCompanionApptTimeslotId(null));
                    }
                  })
                }

                dispatch(updateApptTimeRange({
                  id: timeRange.id,
                  startTime: timeRange.startTime,
                  endTime: timeRange.endTime,
                }));
              });
            }}
          />
        </div>
      </div>
    </>
  );
};

// Dependent on apptDateId, apptTimeRangeStartTime, apptTimeRangeEndTime
export const SelectTimeslot = ({autoSelect}) => {
  const dispatch = useDispatch();
  const { apptDate, locationId, apptTypeId, apptTimeslotId, apptTimeRangeStartTime, 
    apptTimeRangeEndTime, haveCompanion, apptTimeslots, bookingTxnId, apptTimeRangeId, isCrps } = useSelector((state) => state.o2Appointment);

  // ***isCrps will assume haveCompanion

  useEffect(()=>{
    console.log("#getTimeslots mount");
  }, []);

  // console.log("#getTimeslots render");

  useEffect(() => {
    // Refreshing the page may call this multiple times
    if(apptDate === null || apptTypeId === null || locationId === null) {
      return;
    }

    // console.log("#get",  apptDate, apptTypeId, locationId);

    getTimeslots({apptDate:moment(apptDate).format(DATE_FORMAT_API), apptTypeId, locationId}).then(timeslots=>{
      dispatch(updateApptTimeslots(timeslots));
      
    });
  }, [apptDate, apptTypeId, locationId ]);


  useEffect(() => {
    // edit
    if(bookingTxnId) {
      getTimeslots({apptDate:moment(apptDate).format(DATE_FORMAT_API), apptTypeId, locationId}).then(timeslots=>{
        dispatch(updateApptTimeslots(timeslots));
        
      });
    }
  },[bookingTxnId]);

  

  // dispatch(updateInitialApptTimeslotId(null));
  useEffect(()=>{
    // console.log("updateApptTimeslotId initialApptTimeslotId", initialApptTimeslotId);
    // If come back from next page or editing the appointment, autoSelect will be false.
    // Then no need to auto select first timeslot.
    // After any changes, autoSelect will be set to true.
    // @TODO: Need to check if the initial timeslot is still available
    // if(initialApptTimeslotId !== null) {
    if(!autoSelect) {
      return;
    }

    if(apptTimeslots.length > 0) { 
      // console.log("updateApptTimeslotId apptTimeslots[0]", apptTimeslots[0]);
      batch(()=>{
        
        if(haveCompanion || isCrps) {
          // search until found a good pair
          for(let i=0; i<apptTimeslots.length; i++) {
            const nextSlot = getNextTimeSlot(apptTimeslots[i].id);
            // console.log("nextSlot", nextSlot);
            if(nextSlot) {
              dispatch(updateApptTimeslotId(apptTimeslots[i].id));
              dispatch(updateApptDateTime(moment(apptTimeslots[i].apptDateTime).toDate()));
              dispatch(updateCompanionApptTimeslotId(nextSlot.id));
              // Stop after first found
              return;
            }  
          }
        } else {
          dispatch(updateApptTimeslotId(apptTimeslots[0].id));
          dispatch(updateApptDateTime(moment(apptTimeslots[0].apptDateTime).toDate()));
          dispatch(updateCompanionApptTimeslotId(null));
        }
      });
    }
  // }, [apptTimeslots]);
  // }, [apptTimeslots, initialApptTimeslotId, hasTimeslotSelectionChanges]);
  // }, [apptTimeslots, initialApptTimeslotId]);
  }, [apptTimeslots, autoSelect]);

  useEffect(()=>{
    if(haveCompanion || isCrps) {
      const nextSlot = getNextTimeSlot(apptTimeslotId);
      if(nextSlot) {
        dispatch(updateCompanionApptTimeslotId(nextSlot.id));
      } else {
        // what ever have selected is not available now.
        // Deselect
        // dispatch(updateApptTimeslotId(null));
      }
    } else {
      dispatch(updateCompanionApptTimeslotId(null));
    }
  }, [haveCompanion, isCrps]);
  // , apptTimeRangeStartTime, apptTimeRangeEndTime

  const onChangeApptTimeslotId = (timeslotId) => {
    batch(()=>{
      dispatch(updateApptTimeslotId(timeslotId));
      dispatch(updateApptDateTime(moment(apptTimeslots.find(timeslot=>timeslot.id === timeslotId)?.apptDateTime).toDate()));
      if(haveCompanion || isCrps) {
        const nextSlot = getNextTimeSlot(timeslotId);
        if(nextSlot) {
          dispatch(updateCompanionApptTimeslotId(nextSlot.id));
        }
      } else {
        dispatch(updateCompanionApptTimeslotId(null));
      }
    })
  }

  const getNextTimeSlot = (timeSlotId) => {
    const index = apptTimeslots.findIndex((x) => x.id === timeSlotId);
    const nextTimeSlot = apptTimeslots[index + 1];

    if (_.isEmpty(nextTimeSlot)) {
      return null;
    }

    const curTimeSlot = apptTimeslots[index];
    if(!curTimeSlot) {
      return null;
    }
    if (
      moment(nextTimeSlot.text, TIME_SLOT_FORMAT).isSame(
        moment(curTimeSlot.text, TIME_SLOT_FORMAT).add(
          curTimeSlot.timeslotInterval,
          "minutes"
        )
      )
    ) {
      return { id: nextTimeSlot.id, text: nextTimeSlot.text };
    }

    return null;
  };

  const companionTimeslotFilter = ts=> {
    if(haveCompanion || isCrps) {
      if(getNextTimeSlot(ts.id)) {
        return true;
      } 
      return false;
    } 
    return true;
  };

  const rangeTimeslotFilter = ts => {
    if(apptTimeRangeStartTime && apptTimeRangeEndTime) {
      const tsTime = moment(ts.text, TIME_SLOT_FORMAT);
      const tsTimeRangeStart = moment(apptTimeRangeStartTime, TIME_SLOT_FORMAT);
      const tsTimeRangeEnd = moment(apptTimeRangeEndTime, TIME_SLOT_FORMAT);
      if(tsTime.isBetween(tsTimeRangeStart, tsTimeRangeEnd, undefined, "[]")) {
        return true;
      }
      return false;
    }
    return true;
  };

  // Companion filter last timeslot
  // Range filter 
  const _filteredApptTimeslots = apptTimeslots?.filter(companionTimeslotFilter).filter(rangeTimeslotFilter);

  return (
    <>
      <div className="row justify-content-center  sm-mt-32 md-mt-32 lg-mt-24 xl-mt-24" style={{ marginBottom: 16 }}>
        <div className="col-12 col-md-8 col-lg-6">
          <div>
            <div>Select appointment time</div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center pb-3">
        <div className={"col-12 col-md-8 col-lg-6"}>
          <div className="row" style={{ marginLeft: -8, marginRight: -8 }}>
            {_filteredApptTimeslots?.map(({ id, text: scheduleDate }) => (
              <div key={id} className="col-6 col-md-4 col-sm-6" style={{ padding: 0 }}>
                <Radio
                  id="serviceTime"
                  label={scheduleDate}
                  onChange={() => onChangeApptTimeslotId(id)}
                  checked={id === apptTimeslotId}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};


